import React, { memo } from 'react'

import { TFunction } from 'i18next'

import { FlexBox, Text } from '@surglogs-app/ui'

interface MfaAbortTimerTextProps {
  mode: 'setup' | 'login'
  isLastMinute: boolean
  timeLeft: number | null
  t: TFunction<any>
}

export const MfaAbortTimerText = memo(
  ({ mode, isLastMinute, timeLeft, t }: MfaAbortTimerTextProps) => {
    return isLastMinute && timeLeft ? (
      <FlexBox {...{ jc: 'center', mt: 'sm', ac: 'center' }}>
        <Text {...{ variant: 'warning' }}>
          {t(`mfaSetup.countdown.${mode}` as const, {
            seconds: timeLeft.toString(),
          })}
        </Text>
      </FlexBox>
    ) : null
  },
)
